import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import { Body2, H4 } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_SharedSideBar } from '@ep/types/gatsbyTypes';
import getHtmlProp from '@ep/utils/getHtmlProp';
import React from 'react';

export interface SharedSideBarProps {
  sidebars: Gcms_SharedSideBar[];
}

const StyledSideBar = styled.div`
  background-color: ${theme.colors.bannerBlue};
  color: ${theme.colors.white};
  padding: 1rem;
  margin-bottom: 2rem;
`;

const Heading = styled(H4.withComponent('h2'))`
  padding-bottom: 1rem;
  border-bottom: solid 1px ${theme.colors.white};
  margin-bottom: 0;
`;

const Body = styled(Body2)`
  margin-top: 1rem;
`;

const SharedSideBarModule = ({ sidebars }: SharedSideBarProps) => {
  return (
    <Container>
      {sidebars.map(sidebar => (
        <StyledSideBar key={sidebar.id}>
          <Heading>{sidebar.heading}</Heading>
          <Body {...getHtmlProp(sidebar.body.html)} />
        </StyledSideBar>
      ))}
    </Container>
  );
};

export default SharedSideBarModule;
